import { define } from '../../define.js';
import { Skeleton } from './skeleton.js';
export * from './skeleton.js';
define('skeleton', Skeleton);
